import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { PressReleasePdfType } from '@module/mdrt-org/shared/utils/enums/press-release-pdf-type';
import { getImageDimensions } from './get-images-dimensions';
type UsePressReleaseLogosProps = {
  modalType: Nullable<string>;
  pdfHeadingLogoLeft?: null | string;
  pdfHeadingLogoRight?: null | string;
};
export const usePressReleaseLogos = t0 => {
  const $ = _c(6);
  const {
    modalType,
    pdfHeadingLogoLeft,
    pdfHeadingLogoRight
  } = t0;
  const leftLogoWidthRef = useRef(0);
  const leftLogoHeightRef = useRef(0);
  const rightLogoWidthRef = useRef(0);
  const rightLogoHeightRef = useRef(0);
  let t1;
  let t2;
  if ($[0] !== modalType || $[1] !== pdfHeadingLogoLeft || $[2] !== pdfHeadingLogoRight) {
    t1 = () => {
      if (modalType === PressReleasePdfType.MDRTFoundationGrant && pdfHeadingLogoLeft && pdfHeadingLogoRight) {
        const getImagesSizes = async () => {
          const [leftLogoDimensions, rightLogoDimensions] = await Promise.all([getImageDimensions(pdfHeadingLogoLeft), getImageDimensions(pdfHeadingLogoRight)]);
          const leftAspectRatio = leftLogoDimensions.width / leftLogoDimensions.height;
          leftLogoHeightRef.current = 26;
          leftLogoWidthRef.current = leftAspectRatio * leftLogoHeightRef.current;
          const rightAspectRatio = rightLogoDimensions.width / rightLogoDimensions.height;
          rightLogoHeightRef.current = 26;
          rightLogoWidthRef.current = rightAspectRatio * rightLogoHeightRef.current;
        };
        getImagesSizes();
      }
    };
    t2 = [modalType, pdfHeadingLogoLeft, pdfHeadingLogoRight];
    $[0] = modalType;
    $[1] = pdfHeadingLogoLeft;
    $[2] = pdfHeadingLogoRight;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      leftLogoHeightRef,
      leftLogoWidthRef,
      rightLogoHeightRef,
      rightLogoWidthRef
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};